import type React from "react";

type Props = React.HTMLAttributes<HTMLFieldSetElement> & {
	children: React.ReactNode;
};

export const Fieldset = ({ children, ...rest }: Props) => (
	<div>
		<fieldset className="h-full" {...rest}>
			{children}
		</fieldset>
	</div>
);
